module.exports = __webpack_public_path__ + "img/Order.2c8f23e5.png";